import { DisciplineInput } from "./Partials";

// The backend rejects a duplicate discipline in a group; the edited row keeps its own.
const ElectiveGroupDisciplineFields = ({ record, excludeIds = [] }) => (
  <DisciplineInput excludeIds={excludeIds.filter(id => id !== record?.disciplineId)} />
);

export default ElectiveGroupDisciplineFields;
